import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import SaveEditing from '../save/saveediting';
import SaveUI from '../save/saveui';

export default class Save extends Plugin {
  static get requires() {
    return [ SaveEditing, SaveUI ];
  }

  static get pluginName() {
    return 'Save';
  }
}
